import BoardList from './BoardList/BoardList';
import { announcementConfig } from './BoardList/boardListConfigs';

const AnnouncementList = ({ announcements, announcementViews, handleSelectAnnouncement, setAnnouncements, userId, userRole }) => (
    <BoardList
        config={announcementConfig}
        items={announcements}
        views={announcementViews}
        setItems={setAnnouncements}
        onEdit={handleSelectAnnouncement}
        userId={userId}
        userRole={userRole}
    />
);

export default AnnouncementList;
